export const DAO_CODE = 'DASHBOARD_CONSULTANT_ACTIVITY' + '_DAO';
